import { Button } from '@core/ui';
import { PollToggleButtonProps } from './types';

export const PollToggleButton = ({ onClick, children, classNames }: PollToggleButtonProps) => (
    <Button type="button" variant="primary" classNames={`w-full ${classNames}`} onClick={onClick} data-testid="PollToggleButton">
        {children}
    </Button>
);
